import type { Channel, Schedule, ScheduleChannel } from '../types';

export function saoPauloClock(date = new Date()): string {
  return new Intl.DateTimeFormat('pt-BR', {
    timeZone: 'America/Sao_Paulo',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  }).format(date);
}

export function findCurrentPrograms(schedules: Schedule[], clock: string): {
  currentProgram?: Schedule;
  nextProgram?: Schedule;
} {
  const currentIndex = schedules.findIndex(item => item.time_start <= clock && item.time_end >= clock);
  if (currentIndex >= 0) {
    return {
      currentProgram: schedules[currentIndex],
      nextProgram: schedules[currentIndex + 1],
    };
  }
  const nextIndex = schedules.findIndex(item => item.time_start > clock);
  return {
    currentProgram: undefined,
    nextProgram: nextIndex >= 0 ? schedules[nextIndex] : undefined,
  };
}

export function mergeCatalog(
  channels: Channel[],
  scheduleChannels: ScheduleChannel[],
  clock = saoPauloClock(),
): Channel[] {
  const scheduleMap = new Map(scheduleChannels.map(item => [item.id, item.schedules || []]));
  return channels
    .filter(channel => Boolean(channel.url_live_streaming))
    .map(channel => ({
      ...channel,
      schedules: scheduleMap.get(channel.id) || [],
      ...findCurrentPrograms(scheduleMap.get(channel.id) || [], clock),
    }))
    .sort((a, b) => a.channel_number - b.channel_number);
}

export function progressFor(program: Schedule | undefined, clock = saoPauloClock()): number {
  if (!program) return 0;
  const seconds = (value: string) => {
    const [hours, minutes, secs] = value.split(':').map(Number);
    return hours * 3600 + minutes * 60 + secs;
  };
  const start = seconds(program.time_start);
  const end = seconds(program.time_end);
  const now = seconds(clock);
  if (end <= start) return 0;
  return Math.max(0, Math.min(100, ((now - start) / (end - start)) * 100));
}

export function shortTime(value?: string): string {
  return value ? value.slice(0, 5) : '--:--';
}
